// A.5.4F — Mapping VISUEL PUR de l'issue d'orchestration -> badge Journal.
// L'outcome vient du backend (orchestration_diagnostic().outcome), jamais recalculé/parsé côté frontend.
// L'information n'est jamais codée uniquement par la couleur : le label texte est toujours présent.
export function getOrchestrationOutcomeBadge(outcome) {
  const o = (outcome || "").toString().toLowerCase();
  const M = {
    offboard_active: { label: "OFFBOARD acquis", tone: "green", color: "#22C55E" },
    offboard_not_acquired: { label: "OFFBOARD non acquis", tone: "orange", color: "#F59E0B" },
    failed: { label: "Échec", tone: "red", color: "#EF4444" },
    cancelled: { label: "Annulé", tone: "gray", color: "#737373" },
    pilot_override: { label: "Reprise pilote", tone: "amber", color: "#FBBF24" },
    landed: { label: "Atterri", tone: "gray", color: "#737373" },
    rtl: { label: "RTL", tone: "gray", color: "#737373" },
    in_progress: { label: "En cours", tone: "gray", color: "#737373" },
  };
  return M[o] || { label: "Inconnu", tone: "gray", color: "#737373" };
}
